import './styles.css'

function InputForm(props) {
    return (
        <>
            <label className={`block text-sm font-medium text-gray-700 mb-1 ${props.invalid && 'text-red-500'}`}>
                {props.label}
                {!props.optional && <span className="text-red-500"> *</span>}
            </label>
            <input
                style={props.style}
                type={props.type}
                min={props.min}
                max={props.max}
                maxLength={props.maxLength}
                className={`w-full px-4 py-2 border-1 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${props.capitalize && ' capitalize '} ${props.invalid && 'text-red-500 border-red-500'}`}
                id={props.id}
                onBlur={props.onBlur}
                disabled={props.disabled}
                placeholder={props.placeholder}
                value={props.value}
                name={props.name}
                pattern={props.pattern}
                onChange={props.onChange}
                autoComplete={props.autoComplete}
                required={props.required}
                onInput={props.onInput} />
        </>
    )
}

export default InputForm;